import './AppMain.css';
import { useEffect, useState } from 'react';
import BarAppMain from './BarAppMain';
import AppAufa from './aufa/AppAufa';
import ContinerMain from './ContinerMain';

import Massage from '../../design/Massage';
import FetchMassage from '../../../faetures/FetchMassage';


export default function AppMain({ namesList, num_of_docket, aufaFlights, updateDataDocketList, updateDataDocketObject, setCloseMain }) {
    // console.log("in App Main", "namesList", namesList, "num_of_docket", num_of_docket,"aufaFlights", aufaFlights )

    const [aufa, setAufa] = useState({ open: false, data: {} });

    const [massage, setMassage] = useState({ open: false, text: "", fun: () => { } });
    const [massageSend, setMassageSend] = useState({ open: false, data: {}, text: "" });
    const [isAdmin, setIsAdmin] = useState(false)

    useEffect(() => {
        const admin = sessionStorage.getItem('admin') === 'admin';
        setIsAdmin(admin);
    }, [])



    const openMenuAufaData = (event, keyData) => {
        event.preventDefault();

        if (isAdmin && event.ctrlKey) {
            setMassage({
                open: true, text: `האם אתה בטוח שברצונך למחוק דוקט מס' ${keyData}`,
                fun: () => deleteAufaData(keyData)
            })
        } else if (!isAdmin) {
            setMassage({open: true, text: "אין לך הרשאות למחוק דוקט", fun: ()=>{}});
        }
    }

    function deleteAufaData(keyData) {
        setMassageSend({ open: true, data: { num: keyData } });
    }

    const resolveAfterDelete = (resolve) => {
        if (resolve === 'success') {
            setMassageSend({ open: true, text: "נמחק בהצלחה" });
        } else {
            setMassageSend({ open: true, text: "שגיאה" });
        }
    }

    return (
        <>
            <div className={'docketMain'}>
                <div className="barMainDocket">
                    <BarAppMain value={'אעופה'} onClick={() => setAufa({ open: true, data: {} })} />
                    <BarAppMain value={'טיסה'} />
                    <BarAppMain value={'רכב'} />
                    <BarAppMain value={'ביטוח'} />
                    <BarAppMain value={'מלון'} />
                    <BarAppMain value={'ויזה'} />
                </div>

                <div className='docketMainContinerFlight'>
                    {Object.keys(aufaFlights).map((keyAufa) =>
                        <ContinerMain
                            key={keyAufa}
                            data={{ ...aufaFlights[keyAufa] }}
                            onDoubleClick={() => setAufa({ open: true, data: { ...aufaFlights[keyAufa], idDocket: keyAufa } })}
                            deleteAufaData={(event) => openMenuAufaData(event, keyAufa)}
                        />
                    )}
                </div>
            </div>

            {aufa.open &&
                <AppAufa
                    setClose={() => setAufa({ open: false, data: {} })}
                    namesList={namesList}
                    num_of_docket={num_of_docket}
                    data={aufa.data}
                    updateDataDocketList={updateDataDocketList}
                    updateDataDocketObject={updateDataDocketObject}
                    setCloseMain={setCloseMain}
                />}

            {
                massage.open &&
                <Massage
                    text={massage.text}
                    setClose={() => setMassage({ open: false, text: "" })}
                    buttonAgree={() => { massage.fun(); setMassage({ open: false }) }}
                />
            }

            {
                massageSend.open &&
                <FetchMassage
                    url={'docket/delete-aufa-docket'}
                    data={massageSend.data}
                    text={massageSend.text}
                    fun={resolveAfterDelete}
                    setMassage={setMassageSend}
                    setClose={() => setMassageSend({ open: false })}
                />
            }
        </>
    )
}